import { type DevScenarioEntry, devScenarioEntry, mockApiError } from '@arya/shared/msw-cloudflare';

const LOGIN = { method: 'POST', path: '/api/auth/login' } as const;
const SIGN_IN_NOTE = 'The Demo map sign-in fails too while this is on.';

export const SIGN_IN_SCENARIOS: readonly DevScenarioEntry[] = [
  devScenarioEntry(
    {
      name: 'sign-in-429',
      group: 'Sign-in',
      title: 'Too many attempts',
      description: `Signing in answers 429. ${SIGN_IN_NOTE}`,
      screen: '/sign-in',
    },
    LOGIN,
    () => mockApiError(429, 'Too many attempts', { retryAfter: 60 }, { 'Retry-After': '60' })
  ),
  devScenarioEntry(
    {
      name: 'sign-in-locked',
      group: 'Sign-in',
      title: 'Account locked',
      description: `Signing in answers 423 with the time the lock ends. ${SIGN_IN_NOTE}`,
      screen: '/sign-in',
    },
    LOGIN,
    () =>
      mockApiError(423, 'Account is locked', {
        code: 'account_locked',
        lockedUntil: new Date(Date.now() + 15 * 60_000).toISOString(),
      })
  ),
];
